import { boot } from "quasar/wrappers";
import { QBtn, QInput, QSelect } from "quasar";

const defaultsQBtn = {
  unelevated: true,
  noCaps: true,
};

const defaultsQInput = {
  color: "primary",
  hideBottomSpace: true,
  outlined: true,
};

const defaultsQSelect = {
  emitValue: true,
  mapOptions: true,
  outlined: true,
};

export default boot(() => {
  // Button
  Object.keys(defaultsQBtn).forEach((prop) => {
    QBtn.props[prop] =
      Array.isArray(QBtn.props[prop]) === true ||
      typeof QBtn.props[prop] === "function"
        ? { type: QBtn.props[prop], default: defaultsQBtn[prop] }
        : { ...QBtn.props[prop], default: defaultsQBtn[prop] };
  });

  // Input
  Object.keys(defaultsQInput).forEach((prop) => {
    QInput.props[prop] =
      Array.isArray(QInput.props[prop]) === true ||
      typeof QInput.props[prop] === "function"
        ? { type: QInput.props[prop], default: defaultsQInput[prop] }
        : { ...QInput.props[prop], default: defaultsQInput[prop] };
  });

  // Select
  Object.keys(defaultsQSelect).forEach((prop) => {
    QSelect.props[prop] =
      Array.isArray(QSelect.props[prop]) === true ||
      typeof QSelect.props[prop] === "function"
        ? { type: QSelect.props[prop], default: defaultsQSelect[prop] }
        : { ...QSelect.props[prop], default: defaultsQSelect[prop] };
  });
});
